export function versionLabel(version: string): string {
	return `v${version}`;
}
